import React, { useContext } from "react";
import { leadType } from "../../../../app";
import commonContext from "../../../context/common";

function IAgreeEMIRepayment(props) {
    const lead = useContext(commonContext).lead as leadType;
    const utils = useContext(commonContext).utils;
    return (
        <>
            <div className="container my-5 mx-auto px-2 md:px-5">
                <div className="w-full mx-auto">
                    <h2 className="openSans-Reg text-black my-3 md:my-6 text-3xl md:text-3xl lg:text-3xl xl:text-4xl px-0">
                        Mandate Instruction Form for EMI Repayment
                    </h2>

                    <div className="flex flex-wrap w-full my-5">
                        <div className="w-full">
                            <div className="relative w-full md:w-1/2 mb-2 pb-2 md:mb-4 md:pb-4 border-b border-gray-300">
                                <label className="openSans-SemiBold text-sm md:text-lg xl:text-xl text-black">
                                    Date
                                </label>
                                <p className="openSans-SemiBold text-track text-base md:text-lg xl:text-2xl relative">
                                    <span> {utils.getDateInFormat()}</span>
                                </p>
                            </div>
                        </div>
                        <div className="relative w-full md:w-1/2 mb-2 pb-2 md:mb-4 md:pb-4 border-b border-gray-300 pr-0 md:pr-2">
                            <label className="openSans-SemiBold text-sm md:text-lg xl:text-xl text-black">
                                Bank A/C Number{" "}
                            </label>
                            <p className="openSans-SemiBold text-track text-base md:text-lg xl:text-2xl relative">
                                <span>{lead.bankAccount}</span>
                            </p>
                        </div>
                        <div className="relative w-full md:w-1/2 mb-2 pb-2 md:mb-4 md:pb-4 border-b border-gray-300 pl-0 md:pl-2">
                            <label className="openSans-SemiBold text-sm md:text-lg xl:text-xl text-black">
                                With Bank
                            </label>
                            <p className="openSans-SemiBold text-track text-base md:text-lg xl:text-2xl relative">
                                <span>{lead.bankName}</span>
                            </p>
                        </div>
                        <div className="relative w-full md:w-1/2 mb-2 pb-2 md:mb-4 md:pb-4 border-b border-gray-300 pr-0 md:pr-2">
                            <label className="openSans-SemiBold text-sm md:text-lg xl:text-xl text-black">
                                A/c type
                            </label>
                            <p className="openSans-SemiBold text-track text-base md:text-lg xl:text-2xl relative">
                                <span>{lead.accountType}</span>
                            </p>
                        </div>
                        <div className="relative w-full md:w-1/2 mb-2 pb-2 md:mb-4 md:pb-4 border-b border-gray-300 pl-0 md:pl-2">
                            <label className="openSans-SemiBold text-sm md:text-lg xl:text-xl text-black">
                                A/c holder name
                            </label>
                            <p className="openSans-SemiBold text-track text-base md:text-lg xl:text-2xl relative">
                                <span>{`${
                                    lead.pdApplicantFirstName
                                        ? lead.pdApplicantFirstName
                                        : ""
                                } ${
                                    lead.pdApplicantMiddleName
                                        ? lead.pdApplicantMiddleName
                                        : ""
                                } ${
                                    lead.pdApplicantLastName
                                        ? lead.pdApplicantLastName
                                        : ""
                                }`}</span>
                            </p>
                        </div>
                        <div className="relative w-full md:w-1/2 mb-2 pb-2 md:mb-4 md:pb-4 border-b border-gray-300 pr-0 md:pr-2">
                            <label className="openSans-SemiBold text-sm md:text-lg xl:text-xl text-black">
                                IFSC Code
                            </label>
                            <p className="openSans-SemiBold text-track text-base md:text-lg xl:text-2xl relative">
                                <span>{lead.ifsc}</span>
                            </p>
                        </div>
                        <div className="relative w-full md:w-1/2 mb-2 pb-2 md:mb-4 md:pb-4 border-b border-gray-300 pl-0 md:pl-2">
                            <label className="openSans-SemiBold text-sm md:text-lg xl:text-xl text-black">
                                MICR Code
                            </label>
                            <p className="openSans-SemiBold text-track text-base md:text-lg xl:text-2xl relative">
                                <span>{lead.micrCode}</span>
                            </p>
                        </div>
                        <div className="w-full">
                            <div className="relative w-full md:w-1/2 mb-2 pb-2 md:mb-4 md:pb-4 border-b border-gray-300">
                                <label className="openSans-SemiBold text-sm md:text-lg xl:text-xl text-black">
                                    Branch Name
                                </label>
                                <p className="openSans-SemiBold text-track text-base md:text-lg xl:text-2xl relative">
                                    <span>{lead.bankBranchName}</span>
                                </p>
                            </div>
                        </div>
                        <div className="relative w-full mb-2 pb-2 md:mb-4 md:pb-4 border-b border-gray-300">
                            <label className="openSans-SemiBold text-sm md:text-lg xl:text-xl text-black">
                                An Amount of Rupees (Words)
                            </label>
                            <p className="openSans-SemiBold text-track text-base md:text-lg xl:text-2xl relative">
                                <span>
                                    {utils.amountInWord(lead.totalAmount)}
                                </span>
                            </p>
                        </div>
                        <div className="relative w-full mb-2 pb-2 md:mb-4 md:pb-4 border-b border-gray-300">
                            <label className="openSans-SemiBold text-sm md:text-lg xl:text-xl text-black">
                                An Amount of Rupees (Figures)
                            </label>
                            <p className="openSans-SemiBold text-track text-base md:text-lg xl:text-2xl relative">
                                <span>
                                    {utils.currencyFormat(lead.totalAmount)}
                                </span>
                            </p>
                        </div>
                        <div className="relative w-full mb-2 pb-2 md:mb-4 md:pb-4 border-b border-gray-300">
                            <label className="openSans-SemiBold text-sm md:text-lg xl:text-xl text-black">
                                Frequency{" "}
                            </label>
                            <p className="openSans-SemiBold text-track text-base md:text-lg xl:text-2xl relative">
                                <span>Monthly</span>
                            </p>
                        </div>
                        <div className="relative w-full mb-2 pb-2 md:mb-4 md:pb-4 border-b border-gray-300">
                            <label className="openSans-SemiBold text-sm md:text-lg xl:text-xl text-black">
                                Debit Type
                            </label>
                            <p className="openSans-SemiBold text-track text-base md:text-lg xl:text-2xl relative">
                                <span>Maximum Amount</span>
                            </p>
                        </div>
                        <div className="relative w-full md:w-1/2 mb-2 pb-2 md:mb-4 md:pb-4 border-b border-gray-300 pr-0 md:pr-2">
                            <label className="openSans-SemiBold text-sm md:text-lg xl:text-xl text-black">
                                Reference 1
                            </label>
                            <p className="openSans-SemiBold text-track text-base md:text-lg xl:text-2xl relative">
                                <span>{lead.eMandateUrn}</span>
                            </p>
                        </div>
                        <div className="relative w-full md:w-1/2 mb-2 pb-2 md:mb-4 md:pb-4 border-b border-gray-300 pl-0 md:pl-2">
                            <label className="openSans-SemiBold text-sm md:text-lg xl:text-xl text-black">
                                Reference 2
                            </label>
                            <p className="openSans-SemiBold text-track text-base md:text-lg xl:text-2xl relative">
                                <span>Auto Loan</span>
                            </p>
                        </div>
                        <div className="relative w-full md:w-1/2 mb-2 pb-2 md:mb-4 md:pb-4 border-b border-gray-300 pr-0 md:pr-2">
                            <label className="openSans-SemiBold text-sm md:text-lg xl:text-xl text-black">
                                Phone No.
                            </label>
                            <p className="openSans-SemiBold text-track text-base md:text-lg xl:text-2xl relative">
                                <span>{lead.mobile}</span>
                            </p>
                        </div>
                        <div className="relative w-full md:w-1/2 mb-2 pb-2 md:mb-4 md:pb-4 border-b border-gray-300 pl-0 md:pl-2">
                            <label className="openSans-SemiBold text-sm md:text-lg xl:text-xl text-black">
                                E-mail ID
                            </label>
                            <p className="openSans-SemiBold text-track text-base md:text-lg xl:text-2xl relative">
                                <span>{lead.email}</span>
                            </p>
                        </div>
                        <div className="relative w-full md:w-1/2 mb-2 pb-2 md:mb-4 md:pb-4 border-b border-gray-300 pr-0 md:pr-2">
                            <label className="openSans-SemiBold text-sm md:text-lg xl:text-xl text-black">
                                From
                            </label>
                            <p className="openSans-SemiBold text-track text-base md:text-lg xl:text-2xl relative">
                                <span>{utils.getDateInFormat(lead.emiStartDate)}</span>
                            </p>
                        </div>
                        <div className="relative w-full md:w-1/2 mb-2 pb-2 md:mb-4 md:pb-4 border-b border-gray-300 pl-0 md:pl-2">
                            <label className="openSans-SemiBold text-sm md:text-lg xl:text-xl text-black">
                                To
                            </label>
                            <p className="openSans-SemiBold text-track text-base md:text-lg xl:text-2xl relative">
                                <span>Until cancelled</span>
                            </p>
                        </div>
                    </div>
                    <div className="w-full  my-8 text-center">
                        <button
                            onClick={() => props.handleOnOTPSubmit()}
                            className="button-blue-bg text-white py-2 px-4 rounded text-base lg:text-lg xl:text-xl button-blue mr-0 sm:mr-2 md:mr-2 lg:mr-3 xl:mr-4 transition-all"
                            title="I Agree"
                        >
                            {" "}
                            I Agree{" "}
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
}

export default IAgreeEMIRepayment;
